import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  standalone: true,
  selector: 'fl-loading-template',
  template: ` <span class="TemplateBar"></span> `,
  styleUrls: ['./loading-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingTemplateComponent {
  @HostBinding('attr.flHideInEndToEndTests') readonly flHideInEndToEndTests =
    '';
}
